import {
  GetTradeInsuranceCustomerQuery,
  GetTradeInsurancesQuery,
  TradeInsuranceStatus,
} from "../graphql/generated.ts";
import { toHumanReadable } from "../utils/string.ts";

export type TradeInsurance =
  GetTradeInsurancesQuery["tradeInsurances"]["data"][0];
export type TradeInsuranceCustomerStatistics =
  GetTradeInsuranceCustomerQuery["tradeInsuranceCustomer"];

export const tradeInsuranceStatusOptions = Object.values(
  TradeInsuranceStatus
).map((item) => ({
  value: item,
  label: toHumanReadable(item),
}));
